export default "__VITE_ASSET__CH8niM5p__"